import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandContract = trigger('expandContract', [
  state('void', style({ height: 0, opacity: 0, overflow: 'hidden' })),
  transition(':enter', [animate('250ms ease-in', style({ height: '*', opacity: 1 }))]),
  transition(':leave', [style({ overflow: 'hidden' }), animate('250ms ease-out')]),
]);
